(function () {
  function initReviewsSlider() {
    document.querySelectorAll('.js-swiper-reviews').forEach(function (el) {
      if (el.swiper) return;

      var slideCount = el.querySelectorAll('.swiper-slide').length;

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: slideCount > 2,
        grabCursor: true,
        speed: 600,
        autoplay: slideCount > 1
          ? {
              delay: parseInt(el.getAttribute('data-autoplay-speed'), 10) || 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        breakpoints: {
          0:    { spaceBetween: 12 },
          750:  { spaceBetween: 16 },
          1100: { spaceBetween: 24 },
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsSlider);
  } else {
    initReviewsSlider();
  }

  document.addEventListener('shopify:section:load', initReviewsSlider);
})();